<div
    class="loader"
    [ngClass]="{'spinner-sm': size === 'small','spinner-lg': size === 'large' }"
></div>